import { render, staticRenderFns } from "./category.vue?vue&type=template&id=3f681b2c&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
import style0 from "./category.vue?vue&type=style&index=0&id=3f681b2c&prod&lang=css"
import style1 from "./category.vue?vue&type=style&index=1&id=3f681b2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f681b2c",
  null
  
)

export default component.exports